(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ncc-text-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){var link=event.target.closest('[data-ncc-text-cart]');if(!link)return;var apple=/iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);link.href='sms:+13192397831'+(apple?'&':'?')+'body='+link.dataset.nccMessage;});
  } catch(e) { console.error(e); }
})();

})();
